import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ endpoint, method, body }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api[method](endpoint, body);
      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const remittanceSettings = createApi({
  reducerPath: "remittanceSettingsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["remittanceSettings"],
  endpoints: (builder) => ({
    getRemittanceSettings: builder.query({
      query: () => ({
        method: "get",
        endpoint: `admin/remittance/settings`,
      }),
      providesTags: ["remittanceSettings"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        endpoint: `admin/user/fields/update`,
        body,
      }),
      invalidatesTags: ["remittanceSettings"],
    }),
  }),
});

export const {
  useGetRemittanceSettingsQuery,
  useUpdateTableFieldsDataMutation,
} = remittanceSettings;
